import { bloomDemoCollections, bloomDemoProducts } from './beauty/catalog.js';
import { pogoDemoCollections, pogoDemoProducts } from './toys/catalog.js';
import { sbahDemoCollections, sbahDemoProducts } from './coffee/catalog.js';
import { peakDemoCollections, peakDemoProducts } from './supplements/catalog.js';
import { folioDemoCollections, folioDemoProducts } from './books/catalog.js';
import { hearthDemoCollections, hearthDemoProducts } from './homeware/catalog.js';
import { onyxDemoCollections, onyxDemoProducts } from './tech/catalog.js';
const THEME_DEMO_CATALOGS = {
    books: {
        products: (currency) => folioDemoProducts(currency),
        collections: () => folioDemoCollections(),
    },
    homeware: {
        products: (currency) => hearthDemoProducts(currency),
        collections: () => hearthDemoCollections(),
    },
    beauty: {
        products: (currency) => bloomDemoProducts(currency),
        collections: () => bloomDemoCollections(),
    },
    toys: {
        products: (currency) => pogoDemoProducts(currency),
        collections: () => pogoDemoCollections(),
    },
    coffee: {
        products: (currency) => sbahDemoProducts(currency),
        collections: () => sbahDemoCollections(),
    },
    supplements: {
        products: (currency) => peakDemoProducts(currency),
        collections: () => peakDemoCollections(),
    },
    tech: {
        products: (currency) => onyxDemoProducts(currency),
        collections: () => onyxDemoCollections(),
    },
};
/** The active theme's demo catalog, or undefined when it ships none. `Object.hasOwn`, never `in`. */
export function themeDemoCatalog(presetId) {
    return presetId && Object.hasOwn(THEME_DEMO_CATALOGS, presetId)
        ? THEME_DEMO_CATALOGS[presetId]
        : undefined;
}
//# sourceMappingURL=demoCatalogs.js.map